






































































import {Component, Provide, Vue} from 'vue-property-decorator'
import {InputGlobalSchema} from '@/schema/resource/Global/InputGlobalSchema'
import GenericToggleButton from '@/components/misc/GenericToggleButton.vue'
import {Global} from '@/model/resource/Global'

@Component({
  components: {GenericToggleButton},
})
export default class PersistGlobalView extends Vue {
  @Provide('validator') validator = this.$validator

  schema = new InputGlobalSchema()
  global = this.$auth.global

  private normalizeBool(v: unknown, fallback: boolean): boolean {
    if (v === true || v === 'true' || v === 1 || v === '1') return true
    if (v === false || v === 'false' || v === 0 || v === '0') return false
    if (v === null || v === undefined) return fallback
    return Boolean(v)
  }

  /** True means the feature is enabled/active. Defaults to enabled when null. */
  get swapFeatureEnabled(): boolean {
    return this.normalizeBool(this.global?.isSwapFeatureActive, true)
  }

  /** True means Orbit is enabled/active. Defaults to enabled when null. */
  get orbitFeatureEnabled(): boolean {
    return this.normalizeBool(this.global?.isOrbitFeatureActive, true)
  }

  /** True means Bneo is enabled/active. Defaults to enabled when null. */
  get bneoFeatureEnabled(): boolean {
    return this.normalizeBool(this.global?.isBneoFeatureActive, true)
  }

  async created() {
    await this.populate()
  }

  /**
   * If this view is wrapped in <keep-alive>, `created()` runs once.
   * `activated()` runs every time the route is entered again.
   */
  async activated() {
    await this.populate()
  }

  async populate() {
    await this.$await.run('getGlobal', async () => {
      await this.$auth.loadGlobal()
      // Keep local reference in sync with store (in case it was replaced).
      this.global = this.$auth.global
    })
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      this.$toast.abort('system.error.validation')
    }

    await this.global.persistGlobal()
    this.$toast.success('system.success.persist')
  }

  async handleToggleSwapFeature(value: boolean) {
    await Global.toggleSwapFeature(value)
    await this.$auth.loadGlobal()
    this.global = this.$auth.global
    this.$toast.success('system.success.persist')
  }

  async handleToggleOrbitFeature(value: boolean) {
    await Global.toggleOrbitFeature(value)
    await this.$auth.loadGlobal()
    this.global = this.$auth.global
    this.$toast.success('system.success.persist')
  }

  async handleToggleBneoFeature(value: boolean) {
    await Global.toggleBneoFeature(value)
    await this.$auth.loadGlobal()
    this.global = this.$auth.global
    this.$toast.success('system.success.persist')
  }
}
